import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["EnhancedCarousel"] */ "/vercel/path0/src/components/enhanced-carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductCard"] */ "/vercel/path0/src/components/product-card.tsx");
